import React from "react";

function Footer() {
  return (
    <div className="flex items-center justify-center h-[50px] bg-cripten-dark w-full" />
  );
}

export default Footer;
